import { FileTranscriptStatus } from '@/enums';
import type { WorkspaceFileTranscript } from '@/types/workspace';

export function assertCanTranscribeFile(transcript: WorkspaceFileTranscript | null | undefined) {
  return transcript != null && !transcript.id &&
    transcript.meta.canTranscribe &&
    ![FileTranscriptStatus.Complete, FileTranscriptStatus.InProgress].includes(transcript?.status);
}

export function assertCanImportTranscript(transcript: WorkspaceFileTranscript | null | undefined) {
  return transcript != null && !transcript.id &&
    transcript.meta.canConvertToTranscript &&
    ![FileTranscriptStatus.Complete, FileTranscriptStatus.InProgress].includes(transcript?.status);
}